import axios from "axios";
import dotEnv from "dotenv";
dotEnv.config();

const apiURL = process.env.REACT_APP_BASE_URL;

const getCalendarDetailsRequest = ({urlData, timestamp, responseType, allAgents, source}) => {
  const agentIds = []
  allAgents?.forEach((element)=>{
    if(element.selected){
      agentIds.push(element._id)
    }
  })
  return axios.get(`${apiURL}/calendar`, {
    params: {
      ...(urlData?.["offerId"] && { offerId: urlData["offerId"] }),
      ...(urlData?.["propertyId"] && { propertyId: urlData["propertyId"] }),
      ...(urlData?.["openFor"] && { openFor: urlData["openFor"] }),
      ...(agentIds?.length && {agentIds: JSON.stringify(agentIds)}),
      ...(source && { source }),
      timestamp,
      responseType,
    },
    headers: {
      accept: "application/json",
      authorization: `bearer ${urlData["key"]}`,
    },
  });
};

const editCustomTaskRequest = ({taskId, payloadData, urlData}) => {
  const payload = {
    ...payloadData,
    ...(urlData?.transactionType === "BUILDER" ? { propertyId: urlData?.propertyId } : {}),
    ...(urlData?.openFor  ? { openFor: urlData?.openFor } : {}),
  };

  return axios.put(`${apiURL}/tasks/${taskId}`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `bearer ${urlData["key"]}`,
    },
  });
};

// calendar load data for persist
const getCalendarDataRequest = ({urlId}) => {
  const config = {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  };
  return axios(`${apiURL}/url/${urlId}`, config);
};

const getDelegateDetailsRequest = (query, urlData) => {
  // Base URL
  let url = `${apiURL}/delegatesDetail?delegateValue=${query}`;
  
  return axios.get(url, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
      authorization: `bearer ${urlData["key"]}`,
    },
  });
};

const getRemindersListRequest = (dataObject, year) => {
  return axios.get(
    `${apiURL}/reminder?responseType=YEAR&timestamp=${Date.now()}&year=${year}`,
    {
      headers: {
        accept: "application/json",
        authorization: `bearer ${dataObject["key"]}`,
      },
    }
  );
};

const getScheduleListRequest = ({urlData, year, responseType, source}) => {
  let urlString = `${apiURL}/schedules`;
  if (source === 'TRANSACTION_CALENDAR') {
    urlString = `${apiURL}/schedules`
  }
  return axios.get(urlString,
    {
      params: {
        ...((source === 'TRANSACTION_CALENDAR') ? {offerId: urlData?.offerId, openFor: urlData?.openFor} : {responseType, year}),
      },
      headers: {
        accept: "application/json",
        authorization: `bearer ${urlData["key"]}`,
      },
    }
  );
};

const shareCalendarToClientsRequest = ({payloadData, userAuthKey}) => {
  return axios.post(`${apiURL}/shareCalendarToClients`,{
    offerId: payloadData?.offerId,
    ...(payloadData?.propertyId ? { propertyId: payloadData?.propertyId } : {}),
    openFor: payloadData?.openFor,
    clientArray: payloadData?.clientArray,
    ...(payloadData?.subject && { subject: payloadData?.subject }),
    ...(payloadData?.emailSignatureId && {emailSignatureId: payloadData?.emailSignatureId}),
    ...(payloadData?.emailMessage && {emailMessage: payloadData?.emailMessage}),
    ...(payloadData?.readOnlyEmailsArray && { readOnlyEmailsArray: payloadData?.readOnlyEmailsArray }),
    ...(payloadData?.showEmailPreview && { showEmailPreview: payloadData?.showEmailPreview})
  },
  {
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      authorization: `bearer ${userAuthKey}`,
    }
  })
}

export const calendarDataApi = {
  getCalendarDetailsRequest,
  getCalendarDataRequest,
  getRemindersListRequest,
  getScheduleListRequest,
  shareCalendarToClientsRequest,
  editCustomTaskRequest,
  getDelegateDetailsRequest
};
